import { render } from "./CommonRecipeList.vue?vue&type=template&id=1dd593ee&scoped=true&ts=true"
import script from "./CommonRecipeList.vue?vue&type=script&lang=ts"
export * from "./CommonRecipeList.vue?vue&type=script&lang=ts"

import "./CommonRecipeList.vue?vue&type=style&index=0&id=1dd593ee&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd593ee"]])

export default __exports__